
/**
 * Retrieves the luminance value of the provided color and return true if it is considered dark or false if it is considered light
 */

import { HttpParams } from '@angular/common/http';

export function isColorDark(color: string): boolean {
  if (color) {
    const c = color.substring(1);             // strip #
    const r = parseInt(c.substr(0, 2), 16);   // extract red
    const g = parseInt(c.substr(2, 2), 16);   // extract green
    const b = parseInt(c.substr(4, 2), 16);   // extract blue

    const luma = (r * 0.2126) + (g * 0.7152) + (b * 0.0722); // per ITU-R BT.709

    if (luma < 180) {
      return true;
    } else {
      return false;
    }
  }
}

/**
 * Creates an HttpParams class with all the queries
 */
export function getParams(queries: Array<{ key: string; value: any }>): HttpParams {
  let params = new HttpParams();

  for (const query of queries) {
    for (const [key, value] of Object.entries(query)) {
      if (Array.isArray(value)) {
        value.forEach(el => {
          params = params.append(`${key}`, el);
        });
      } else {
        params = params.append(key, value);
      }
    }
  }
  return params;
}

export function copyToClipboard(text: string) {
  navigator.clipboard.writeText(text);
}
